import React, { useState } from "react";

const MembershipSection = ({
  selectedMembership,
  setSelectedMembership,
  onSave, // Callback to handle the submission of dropdown data
}) => {
  const [isOpen, setIsOpen] = useState(false); // Dropdown toggle state
  const [dropdownValue, setDropdownValue] = useState("AFASA"); // Default value of the first box

  const dropdownOptions = [
    "Option 1: Agriculture Group",
    "Option 2: Environmental Club",
    "Option 3: Farmers Association",
    "Option 4: Local Cooperative",
    "Option 5: Community Outreach",
  ]; // 5 options for the dropdown

  const handleBoxClick = (index) => {
    setSelectedMembership(index === 0 ? dropdownValue : "Others");
  };

  const handleDropdownSelect = (value) => {
    setDropdownValue(value); // Update the displayed value in the first box
    setIsOpen(false); // Close the dropdown
    if (onSave) {
      // Submit the selected membership and dropdown value
      onSave({ selectedMembership: value, dropdownValue: value });
    }
  };

  return (
    <div className="space-y-2">
      {/* Heading */}
      <div>
        <h3 className="font-bold text-black text-[8px] md:text-[32px]">
          Memberships, Affiliations, Groups and Associations
        </h3>
        <p className="md:text-[24px] text-[6px] italic font-light text-black">
          What other organization groups or affiliations are you a member of, or are involved with:
        </p>
      </div>
      <div className="md:h-2"></div>
      {/* Boxes */}
      <div className="flex flex-col space-y-2">
        {/* First Box with Dropdown */}
        <div
          className={`relative md:h-[71px] h-[20px] flex items-center justify-between px-4 rounded-[5px] cursor-pointer ${
            selectedMembership === dropdownValue ? "bg-[#03897B] text-white" : "bg-[#03897B] text-white"
          }`}
          onClick={() => handleBoxClick(0)}
        >
          <span className="font-medium md:pl-6 text-[6px] md:text-[18px]">{dropdownValue}</span>
          {/* Dropdown Trigger */}
          <div
            className="absolute top-0 right-0 w-[20px] h-[30px] md:h-full md:w-[85px] bg-[#152C24] text-white flex justify-center items-center rounded-r-[5px] cursor-pointer"
            onClick={(e) => {
              e.stopPropagation(); // Prevent parent click
              setIsOpen((prev) => !prev);
            }}
          >
            <img
              src="https://res.cloudinary.com/dzngpgki4/image/upload/v1746721481/Expand_down_1_fv91ph.png"
              alt="expand"
              className="w-2 h-2 md:w-9 md:h-[35px]"
            />
          </div>
          {/* Dropdown Menu */}
          {isOpen && (
            <div className="absolute top-full right-0 text-black w-full bg-white shadow-lg rounded-md mt-1 z-10">
              {dropdownOptions.map((option, index) => (
                <div
                  key={index}
                  className="px-4 py-2 hover:bg-gray-100 cursor-pointer"
                  onClick={() => handleDropdownSelect(option)}
                >
                  {option}
                </div>
              ))}
            </div>
          )}
        </div>
        {/* Second Box */}
        <div
          onClick={() => handleBoxClick(1)}
          className={`md:h-[71px] h-[20px] flex items-center px-4 rounded-[5px] cursor-pointer ${
            selectedMembership === "Others" ? "bg-[#03897B] text-white" : "bg-[#03897B] text-white"
          }`}
        >
          <span className="font-medium md:pl-6 text-[6px] md:text-[18px]">Others</span>
        </div>
      </div>
    </div>
  );
};

export default MembershipSection;